
import { type } from '@testing-library/user-event/dist/type'
import React from 'react'
import writeXlsxFile from 'write-excel-file'
import { FileCode } from '@phosphor-icons/react'



const Excel = (props) => {

  const propertyschema = [
    {
      column: 'ID',
      type: Number,
      width: 5,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.id
    },
    {
      column: 'Project Name',
      type: String,
      width: 25,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.project?.name
    },
    {
      column: 'Building Name',
      width: 15,
      wrap: false,
      type: String,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.building?.building_no
    },
    {
      column: 'Gala Number',
      width: 15,
      type: Number,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => Number(student.gala?.gala_no)
    },
    {
      column: 'Area Owns',
      width: 15,
      type: Number,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => Number(student.sold_gala_area)
    },
    {
      column: 'Rent Area',
      width: 15,
      wrap: false,
      type: Number,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.rent_area
    },
    {
      column: 'Available Area',
      width: 15,
      type: Number,
      align: 'center',
      wrap: false,
      borderStyle: 'thin',
      value: student => Number(student.sold_gala_area) - Number(student.rent_area)
    },
  ]
  const investorschema = [
    {
      column: 'Ownership',
      width: 15,
      wrap: true,
      type: Number,
      align: 'center',
      borderStyle: 'thin',
      value: student => Number(student?.ownership)
    },
    {
      column: 'Party Name',
      width: 40,
      wrap: true,
      type: String,
      align: 'left',
      borderStyle: 'thin',
      value: student => student.Investors?.name
    },
    {
      column: 'Aadhar Number',
      width: 15,
      wrap: true,
      type: String,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.Investors?.aadhar_no != 'null' ? student.Investors?.aadhar_no : ''
    },
    {
      column: 'Pan Number',
      width: 15,
      wrap: true,
      type: String,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.Investors?.pan_no != 'null' ? student.Investors?.pan_no.toUpperCase() : ''
    },
    {
      column: 'GST Number',
      width: 18,
      wrap: true,
      type: String,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.Investors?.gst != 'null' ? student.Investors?.gst : ''
    },
    {
      column: 'Index Number',
      width: 15,
      wrap: true,
      type: String,
      align: 'center',
      borderStyle: 'thin',
      value: student => student?.index == "" ? "NA" : student?.index
    },
    {
      column: 'Building Name',
      width: 15,
      wrap: false,
      type: String,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.building?.building_no
    },
    {
      column: 'Gala Number',
      width: 15,
      type: Number,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => Number(student.gala?.gala_no)
    },
    {
      column: 'Sub-Gala',
      width: 15,
      type: String,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => student?.sub_gala_name
    },
    {
      column: 'Area Owns',
      width: 15,
      type: Number,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => Number(student?.sold_gala_area)
    },
  ]

  const galaSchema = [
    {
      column: 'Building Number',
      width: 15,
      wrap: false,
      type: String,
      align: 'left',
      borderStyle: 'thin',
      value: gala => gala.building?.building_no
    },
    {
      column: 'Gala No',
      width: 15,
      wrap: false,
      type: Number,
      align: 'center',
      borderStyle: 'thin',
      value: gala => Number(gala?.gala_no)
    },
    {
      column: 'Builtup Area',
      width: 15,
      wrap: false,
      type: Number,
      align: 'center',
      borderStyle: 'thin',
      value: gala => Number(gala?.builtup_area)
    },
    {
      column: 'Sold Area',
      width: 15,
      wrap: false,
      type: Number,
      align: 'center',
      borderStyle: 'thin',
      value: gala => Number(parseFloat(gala?.builtup_area) - parseFloat(gala?.available_area))
    },
    {
      column: 'Reamining Area',
      width: 15,
      wrap: false,
      type: Number,
      align: 'center',
      borderStyle: 'thin',
      value: gala => Number(gala.available_area)
    },]

  const pocschema = [
    {
      column: 'ID',
      type: Number,
      width: 5,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.id
    },
    {
      column: 'Name',
      type: String,
      width: 30,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.poc_name
    },
    {
      column: 'Email',
      type: String,
      width: 30,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.poc_email
    },
    {
      column: 'Contact Number',
      type: String,
      width: 15,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.poc_contact_number
    },
    {
      column: 'Designation',
      type: String,
      width: 15,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.poc_desigation
    },
    {
      column: 'Comment',
      type: String,
      width: 15,
      wrap: false,
      align: 'center',
      borderStyle: 'thin',
      value: student => student.poc_comment
    },
  ]

  const Investors = async () => {
    await writeXlsxFile([props.data, props.poc], {
      schema: [propertyschema, pocschema],
      sheets: ['Properties', 'POC Details'],
      fileName: 'file.xlsx',
      headerStyle: {
        backgroundColor: '',
        fontWeight: 'bold',
        align: 'center',
        borderStyle: 'thin'
      },
    })
  }

  const SoldGala = async () => {
    await writeXlsxFile([props.data.sort((a, b) => a?.building.building_no?.localeCompare(b.building.building_no))], {
      schema: [investorschema],
      sheets: ['Investors'],
      fileName: 'Investors_Details.xlsx',
      headerStyle: {
        backgroundColor: '',
        fontWeight: 'bold',
        align: 'center',
        borderStyle: 'thin'
      },
    })
  }

  const Gala = async () => {
    await writeXlsxFile([props.data.sort((a, b) => a?.building.building_no?.localeCompare(b.building.building_no))], {
      schema: [galaSchema],
      sheets: ['Gala'],
      fileName: 'Gala_Details.xlsx',
      headerStyle: {
        backgroundColor: '',
        fontWeight: 'bold',
        align: 'center',
        borderStyle: 'thin'
      },
    })
  }

  return (
    <>
      {
        <>
          {props.investor != undefined && props.investor &&
            <button onClick={props.soldgala == true ? SoldGala : Investors} className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5 mb-5 buttons py-4 btn btn-secondary btn btn-secondary"> <FileCode size="28" /> <span className="fs-4 d-flex gap-3 title-font-600 px-3"> {"Excel"}</span></button>}

          {props.gala != undefined && (<button onClick={Gala} className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5 mb-5 buttons py-4 btn btn-secondary btn btn-secondary"> <FileCode size="28" /> <span className="fs-4 d-flex gap-3 title-font-600 px-3"> {"Excel"}</span></button>)}
        </>
      }
    </>
  )
}

export default Excel